import React from "react";

const AccessDenied = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Access Denied</h1>
      <p style={styles.message}>You do not have permission to access this application.</p>
      <button style={styles.button} onClick={() => (window.location.href = "/")}>
        Go to Home
      </button>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    backgroundColor: "#f8f9fa",
    textAlign: "center",
  },
  title: {
    fontSize: "2rem",
    color: "#dc3545",
    marginBottom: "10px",
  },
  message: {
    fontSize: "1rem",
    color: "#6c757d",
    marginBottom: "20px",
  },
  button: {
    padding: "10px 20px",
    fontSize: "1rem",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default AccessDenied;
